import React from "react";
import { Col, Input, Label } from "reactstrap";
import { useTranslation } from "react-i18next";
import { TIPOS_CONTENEDOR, MODALIDADES, QUIEN_PAGA, useRevalidadores } from "./contenedorUtils";

// Puerto de una lista (catálogo de Puertos). Si el valor guardado no está en el catálogo se conserva
// como opción para no perderlo; sin catálogo cargado se deja capturar texto.
export function PuertoSelect({ tipo, value, onChange, puertos, required }) {
  const [t] = useTranslation("global");
  const lista = (puertos || []).filter((p) => p.tipo === tipo);
  if (!lista.length) {
    return <Input type="text" value={value || ""} required={required} onChange={(e) => onChange(e.target.value)} />;
  }
  const fuera = value && !lista.some((p) => p.name === value) && value !== "NA";
  return (
    <Input type="select" value={value || ""} required={required} onChange={(e) => onChange(e.target.value)}>
      <option value="">{t("Selecciona")}</option>
      {fuera ? <option value={value}>{value} ({t("fuera del catálogo")})</option> : null}
      {lista.map((p) => (
        <option key={p._id} value={p.name}>
          {p.name}{p.codigo ? ` · ${p.codigo}` : ""}
        </option>
      ))}
    </Input>
  );
}

// Quién revalida (catálogo). Si el valor guardado ya no está activo se conserva como opción.
export function RevalidadorSelect({ value, onChange }) {
  const [t] = useTranslation("global");
  const lista = useRevalidadores();
  const fuera = value && !lista.some((r) => r.name === value);
  return (
    <Input type="select" value={value || ""} onChange={(e) => onChange(e.target.value)}>
      <option value="">{t("Selecciona")}</option>
      {fuera ? <option value={value}>{value}</option> : null}
      {lista.map((r) => <option key={r._id} value={r.name}>{r.name}</option>)}
    </Input>
  );
}

/**
 * Datos nuevos del embarque (tipo, booking, proveedor, referencia del cliente, modalidad, quién paga, quién revalida).
 *  props: valores {tipoContenedor, booking, proveedor, referenciaCliente, modalidad, quienPaga, quienRevalida, blNumero?},
 *         set(campo, valor), md (ancho de cada columna), conBL (muestra el campo BL),
 *         quienPagaObligatorio (cliente, broker y quién paga son obligatorios en altas nuevas)
 */
export default function CamposEmbarque({ valores, set, md = 2, conBL = false, quienPagaObligatorio = false }) {
  const [t] = useTranslation("global");
  const v = valores || {};
  const texto = (campo, label, placeholder) => (
    <Col md={md} className="mb-2">
      <Label>{t(label)}</Label>
      <Input type="text" placeholder={placeholder} value={v[campo] || ""} onChange={(e) => set(campo, e.target.value)} />
    </Col>
  );
  const lista = (campo, label, opciones, requerido) => (
    <Col md={md} className="mb-2">
      <Label>{t(label)}</Label>
      <Input type="select" value={v[campo] || ""} required={requerido} onChange={(e) => set(campo, e.target.value)}>
        <option value="">{t("Selecciona")}</option>
        {opciones.map((o) => <option key={o} value={o}>{t(o)}</option>)}
      </Input>
    </Col>
  );
  return (
    <>
      {lista("tipoContenedor", "Tipo de contenedor", TIPOS_CONTENEDOR)}
      {texto("booking", "Booking")}
      {conBL ? texto("blNumero", "BL") : null}
      {texto("proveedor", "Proveedor")}
      {texto("referenciaCliente", "Referencia del cliente")}
      {lista("modalidad", "Modalidad", MODALIDADES)}
      {lista("quienPaga", "Quién paga", QUIEN_PAGA, quienPagaObligatorio)}
      <Col md={md} className="mb-2">
        <Label>{t("Quién revalida")}</Label>
        <RevalidadorSelect value={v.quienRevalida} onChange={(valor) => set("quienRevalida", valor)} />
      </Col>
    </>
  );
}
